import React, { Component, KeyboardEvent } from 'react';
import { ISuggestionLink } from '../searchresultpage.d';
import styles from './suggestion-link.scss';
import {
    PageViewLogDataId,
    SearchTelemetryAjaxCaller,
    SearchTelemetryData,
} from '../SearchTelemetryAjaxCaller';

export default class SuggestionLinks extends Component<{
    suggestionLink: ISuggestionLink;
    magicLink: string;
    isDesktop: boolean;
    labelText: string;
}> {
    constructor(props) {
        super(props);
    }

    public render() {
        const tabNavAttribute = this.props.isDesktop ? { focusable: true } : {};
        const labelText = `${this.props.suggestionLink.searchTerm.toLowerCase()}, ${this.props.labelText}`;
        const stm = this.props.suggestionLink.telemetryDataViewModel
            ? this.props.suggestionLink.telemetryDataViewModel.stm
            : null;

        return (
            <div className={styles.suggestion_link_wrapper}>
                <a
                    className={styles.suggestion_link}
                    href={this.props.suggestionLink.target}
                    data-stm={stm}
                    onClick={() => this.handleTelemetry(stm)}
                    {...tabNavAttribute} 
                    onKeyDown={(e) => this.handleTabNavigation(e)}
                    aria-label={labelText}
                >
                    {this.props.suggestionLink.searchTerm.toLowerCase()}
                </a>
            </div>
        );
    }

    private handleTabNavigation(event: KeyboardEvent<HTMLAnchorElement>): void {
        if (event.key === ' ') {
            event.preventDefault(); // prevent page jump
            event.currentTarget?.click();
        }
    }

    private handleTelemetry(stm: string): void {
        if (!stm) return;
        const data = new SearchTelemetryData(
            stm,
            PageViewLogDataId.getInstance().get(),
            this.props.suggestionLink.portal,
            this.props.suggestionLink.culture,
            this.props.magicLink
        );
        SearchTelemetryAjaxCaller.postData(data);
    }
}
